var React = require('react');

function EditIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 8.21A6.21 6.21 0 0 0 15.79 2c-.391 0-.766.155-1.043.432L2.586 14.593A2 2 0 0 0 2 16.008V22h5.993a2 2 0 0 0 1.414-.586L21.568 9.253C21.845 8.976 22 8.6 22 8.21zm-2.005-.212L7.993 20H4v-3.992L16.002 4.005a4.21 4.21 0 0 1 3.993 3.993z","fill":"#fff"}));
}

EditIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EditIcon;

EditIcon.default = EditIcon;
